import React, { useState, useEffect } from 'react';
import socket from '../socket';

function generateRoomCode(length = 4) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  return Array.from({ length }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
}

function RoomJoin({ onJoinComplete, language, copy }) {
  const [name, setName] = useState('');
  const [roomCode, setRoomCode] = useState('');
  const [players, setPlayers] = useState([]);

  const handleJoin = () => {
    if (!name || !roomCode) return;
    let clientId = localStorage.getItem('clientId');
    if (!clientId) {
      clientId = crypto.randomUUID();
      localStorage.setItem('clientId', clientId);
    }
    socket.emit('join-room', roomCode, name, clientId);
    onJoinComplete(name, roomCode);
  };

  const handleCreateRoom = () => {
    const code = generateRoomCode();
    setRoomCode(code);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleJoin();
  };

  useEffect(() => {
    socket.on('player-list', (playerList) => {
      setPlayers(playerList);
    });
    return () => {
      socket.off('player-list');
    };
  }, []);

  return (
    <div style={{ textAlign: 'center' }} dir={language === 'he' ? 'rtl' : 'ltr'}>
      <h2>{copy.heading}</h2>
      <div style={{ marginBottom: '0.75em' }}>
        <input
          type="text"
          placeholder={copy.namePlaceholder}
          value={name}
          onChange={e => setName(e.target.value)}
          onKeyDown={handleKeyDown}
        />
      </div>
      <div style={{ marginBottom: '0.75em' }}>
        <input
          type="text"
          placeholder={copy.roomPlaceholder}
          value={roomCode}
          onChange={e => setRoomCode(e.target.value.toUpperCase())}
          onKeyDown={handleKeyDown}
        />
      </div>
      <div
        style={{
          marginTop: '1rem',
          display: 'flex',
          gap: '0.75rem',
          justifyContent: 'center',
          flexWrap: 'wrap',
        }}
      >
        <button onClick={handleJoin}>{copy.joinButton}</button>
        <button onClick={handleCreateRoom}>{copy.createButton}</button>
      </div>

      {players.length > 0 && (
        <div style={{ marginTop: '1em' }}>
          <h4>{copy.playersTitle}</h4>
          <ul>
            {players.map(({ id, name }) => (
              <li key={id}>{name}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default RoomJoin;

